<p-dialog [(visible)]="visible"
          [baseZIndex]="10000"
          [modal]="true"
          [closeOnEscape]="false"
          [draggable]="false"
          [keepInViewport]="false"
          [resizable]="false"
          [focusOnShow]="true"
          [closable]="false"
          styleClass="modale-small">
	<p-header>{{ 'SIGALE_ANGULAR.COMPONENTS.MODAL_LOGIN.TITRE' | translate }}</p-header>
	<login [peutModifierLogin]="peutModifierLogin" [loginData]="loginData" [rafraichirLogin]="true" (loginEnSucces)="loginSucces()"></login>
</p-dialog>
